import {Component, ErrorHandler, inject, LOCALE_ID, OnInit, ViewEncapsulation} from '@angular/core';
import {first, mapTo, startWith} from 'rxjs/operators';
import {ErrorHandlingService} from './service/handlers/error-handling.service';
import {RoutesService} from './service/routes.service';
import {FaIconLibrary, FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {FullviewIoService} from "./service/fullview-io.service";
import {fas} from "@fortawesome/pro-solid-svg-icons";
import {IconPack} from "@fortawesome/fontawesome-svg-core";
import {far} from "@fortawesome/pro-regular-svg-icons";
import {fal} from "@fortawesome/pro-light-svg-icons";
import {fab} from "@fortawesome/free-brands-svg-icons";
import {environment} from "@environments/environment";
import { CommonModule, DatePipe } from "@angular/common";
import {AppRoutingModule} from "./app.routing";
import {HttpClientModule, HttpClientXsrfModule} from "@angular/common/http";

import {RxNgZoneSchedulerModule} from "ngx-rxjs-zone-scheduler";
import {DigitlistPipe} from "./rma-pipes/digitlist.pipe";
import {RouterOutlet} from "@angular/router";

import { ConfirmationService } from "primeng/api";
import { IbpConfirmDialogComponent } from "./ibp-components/third-party/ibp-prime-ng/ibp-confirm-dialog/ibp-confirm-dialog.component";
import { IbpBlockingOverlayComponent } from "./ibp-components/third-party/ibp-prime-ng/ibp-blocking-overlay/ibp-blocking-overlay.component";
import { AsyncPipe } from "@angular/common";

@Component({
  selector: 'rma-body',
  templateUrl: './app.component.html',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    AppRoutingModule,
    HttpClientModule,
    FontAwesomeModule,
    HttpClientXsrfModule,
    RxNgZoneSchedulerModule,
    RouterOutlet,
    IbpConfirmDialogComponent,
    IbpBlockingOverlayComponent,
    AsyncPipe,
  ],
  providers: [
    ConfirmationService,
    DigitlistPipe,
    DatePipe,
    {
      provide: LOCALE_ID,
      useValue: 'de-CH',
    },
  ],
})
export class AppComponent {
  private errorHandlingService = inject(ErrorHandlingService);
  private library = inject(FaIconLibrary);
  private fullviewIoService = inject(FullviewIoService);

  private routes: RoutesService = inject(RoutesService);

  public appLoaded$ = this.routes.navigationEnd$.pipe(first(),
    mapTo(true),
    startWith(false));

  constructor() {
    this.errorHandlingService.init();
    this.library.addIconPacks(fas as IconPack);
    this.library.addIconPacks(far as IconPack);
    this.library.addIconPacks(fal as IconPack);
    this.library.addIconPacks(fab as IconPack);
    if (environment.fullviewEnabled) {
      this.fullviewIoService.injectFullviewScript();
    }
  }
}
